import moment from 'moment';
export default {
	searchParams: SEARCH_PARAMS(),
	powTourRgstManagements: [],
	powLnCdList: [], //조회조건에 라인
	insnCyclCdList: [], //조회조건에 주기
	insnRsltCdList: [], //조회조건에 결과
	gridInsnRsltCdList: [], //그리드에 결과
	resultMaster: RESULT_MASTER(), //공정순회검사 마스터 한건
	resultList: [], //공정순회검사 상세리스트
	fileList: [], //파일첨부 디테일 조회할때
	selectedRows: []
};

function SEARCH_PARAMS() {
	return {
		powLnCd: 'DC',
		insnRsltCd: '',
		insnDd: moment().format('YYYYMMDD'),
		ipnNos: '1',
		insnCyclCd: ''
	};
}

function RESULT_MASTER() {
	return {
		powLnCd: '', //라인
		oldInsnDd: '', //검사일(old)
		newInsnDd: moment().format('YYYYMMDD'), //검사일(new)
		oldIpnNos: '',
		newIpnNos: '',
		insnPrvsCt: '', //검사항목수
		okPrvsCt: '', //적합항목수
		ngPrvsCt: '', //부적합항목수
		pprrId: '', //작성자id
		pprrNm: '', //작성자성명
		pprrDd: '', //작성일
		fileId: '', //첨부파일id
		rgnId: '', //등록자ID
		rgnDt: '', //등록일자
		fileList: [], //파일첨부
		delFileList: [] //삭제할파일첨부
	};
}

export { SEARCH_PARAMS, RESULT_MASTER };
